export const USER_NAMESPACE = 'user'
export const USER_REQUEST = 'userRequest'
export const USER_SUCCESS = 'userSuccess'
export const USER_ERROR = 'userError'
export const USER_PROFILE = 'getProfile'
export const USER_PROFILE_LOADED = 'isProfileLoaded'
export const USER_API_GOOGLE_MAPS_KEY = 'getUserGoogleMapsApiKey'



// WEBPACK FOOTER //
// ./src/store/actions/user.js